
export default {
  props: {
    latLng: {
      type: Object,
      required: true,
    },
    zoom: {
      type: Number,
      default: 16,
    },
  },
  data () {
    return {
      url: `https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
    };
  },
};
